import _styled from "@emotion/styled/base";
import isPropValid from '@emotion/is-prop-valid';
export var Description = /*#__PURE__*/_styled("div", true ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop) && prop !== "color";
  },
  target: "e1q5ntsr0"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop) && prop !== "color";
  },
  target: "e1q5ntsr0",
  label: "Description"
})(function (_ref) {
  var theme = _ref.theme;
  return theme.typography.textRegularSmall;
}, ";color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";padding-top:4px;" + (true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvSW50ZWdyYXRpb25DYXJkL0Rlc2NyaXB0aW9uL0Rlc2NyaXB0aW9uLnZpZXdzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVVnSCIsImZpbGUiOiIvd29ya2Rpci9saWJzL21hdGNoYS9yZWNpcGVzL0ludGVncmF0aW9uQ2FyZC9EZXNjcmlwdGlvbi9EZXNjcmlwdGlvbi52aWV3cy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5pbXBvcnQgaXNQcm9wVmFsaWQgZnJvbSAnQGVtb3Rpb24vaXMtcHJvcC12YWxpZCdcblxuaW1wb3J0IHR5cGUgeyBUaGVtZUNvbG9ycyB9IGZyb20gJ0BzZWdtZW50L21hdGNoYS9mb3VuZGF0aW9ucy9UaGVtZSdcblxuZXhwb3J0IGludGVyZmFjZSBEZXNjcmlwdGlvblByb3BzIHtcbiAgY29sb3I6IFRoZW1lQ29sb3JzXG59XG5cbmV4cG9ydCBjb25zdCBEZXNjcmlwdGlvbiA9IHN0eWxlZChgZGl2YCwgeyBzaG91bGRGb3J3YXJkUHJvcDogKHByb3ApID0+IGlzUHJvcFZhbGlkKHByb3ApICYmIHByb3AgIT09IGBjb2xvcmAgfSlgXG4gICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUudHlwb2dyYXBoeS50ZXh0UmVndWxhclNtYWxsfTtcbiAgY29sb3I6ICR7KHsgY29sb3IgfSkgPT4gY29sb3J9O1xuICBwYWRkaW5nLXRvcDogNHB4O1xuYFxuIl19 */"));